module.exports = __webpack_public_path__ + "9d329b26749dcaed02b2e35f8212a94e.svg";